<template>
    <v-card>
        <v-card-text class="pb-1">
            <v-row>
                <v-col
                    class="pr-0"
                    cols="5">
                    <v-text-field
                        outlined
                        hide-details
                        height="40px"
                        append-icon="search"
                        v-model="pagination.search"
                        :placeholder="$t('placeholder.filterBySaleNameEmailAndPhone')"/>
                </v-col>
                <v-col cols="2">
                    <v-select
                        outlined
                        hide-details
                        v-model="pagination.type"
                        v-on:change="changesubRoles"
                        append-icon="expand_more"
                        height="40px"
                        item-value="value"
                        item-text="text"
                        :menu-props="{
                            offsetY: true
                        }"
                        :items="typeList"/>
                </v-col>
                <v-col cols="2">
                    <v-select
                        outlined
                        hide-details
                        v-model="pagination.status"
                        v-on:change="changeStatus"
                        append-icon="expand_more"
                        height="40px"
                        item-value="value"
                        item-text="text"
                        :menu-props="{
                            offsetY: true
                        }"
                        :items="statusList"/>
                </v-col>
                <v-col cols="3">
                    <v-btn
                        class="font-weight-regular"
                        color="primary"
                        @click="getExportExcel">
                        <icon
                            class="mr-2"
                            value="file_download"
                            size="18px"/>
                        {{ $t('button.exportXlsx') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <sale-agent-table
                :search="pagination.search"
                :items="saleAgents"
                :options="pagination"
                :excludeHeaders="[
                    $constant.table.SALE_AGENT_KEY.isVerified,
                    $constant.table.SALE_AGENT_KEY.email,
                    $constant.table.SALE_AGENT_KEY.phonenumber,
                    $constant.table.SALE_AGENT_KEY.totalAmount,
                    $constant.table.SALE_AGENT_KEY.totalTickets,
                    $constant.table.SALE_AGENT_KEY.createdAt,
                    $constant.table.SALE_AGENT_KEY.totalCommission
                ]"
                @viewDetails="openSaleAgentDetails"/>
        </v-card-text>

        <right-panel
            ref="updateSaleAgentPanel"
            :title="$t('saleAgent.saleAgentByCategoryDetails')">
            <template v-slot:content="{ context }">
                <sale-agent-details-view
                    ref="saleAgentDetailsView"
                    :saleAgent="context"
                    :visibleBottom="'isActive'"
                    :disablerole="true"
                    @closeRightPanel="closeRightPanel"/>
            </template>
            <template v-slot:bottom>
                <button-status-field
                    :status="$constant.ACTIVE_STATUS"
                    :status_color='agentdetail.isActive'
                    @click="onClickPanelActive"/>
                <button-status-field
                    class="ml-0"
                    :status="$constant.INACTIVE_STATUS"
                    :status_color='agentdetail.isActive'
                    @click="onClickPanelInActive"/>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary"
                    @click="onClickPanelSave">
                    {{ $t('button.save') }}
                </v-btn>
            </template>
        </right-panel>
    </v-card>
</template>

<script>
import SaleAgentTable from '@/components/tables/SaleAgentTable'
import RightPanel from '@/components/panels/RightPanel'
import SaleAgentDetailsView from '@/views/SaleAgentDetailsView'
import ButtonStatusField from '@/components/fields/ButtonStatusField'
import { mapState } from 'vuex'
// import FileSaver from 'file-saver'

export default {
    name: 'SaleAgentByCategoryListView',

    components: {
        SaleAgentTable,
        RightPanel,
        SaleAgentDetailsView,
        ButtonStatusField
    },

    computed: {
        ...mapState('saleagentList', ['agentlist', 'agentdetail'])
    },

    props: {
        saleAgents: {
            type: Array,
            default: () => []
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            typeList: [
                'ทุกประเภทตัวแทน',
                'Street Counter',
                'Taxi / Van',
                'Tour Agency',
                'Hotel Concierge'
            ],
            statusList: [
                this.$constant.ACTIVE_STATUS,
                this.$constant.INACTIVE_STATUS,
                this.$constant.ALL_STATUS
            ]
        }
    },

    methods: {
        openSaleAgentDetails (saleAgent) {
            const cloneSaleAgent = JSON.parse(JSON.stringify(saleAgent))
            this.$store.commit('saleagentList/setAgentdetail', saleAgent)
            this.$refs.updateSaleAgentPanel.open(cloneSaleAgent)
        },
        changeStatus (value) {
            var optionData = {}
            if (value === 'all status') {
                optionData = {
                    roles: 'sales-agent',
                    isVerified: 'approve'
                }
            } else {
                optionData = {
                    roles: 'sales-agent',
                    isVerified: 'approve',
                    isActive: value
                }
            }
            this.$store.commit('saleagentList/setOption', optionData)
            this.$store.dispatch('saleagentList/fetchAgentlist')
        },
        changesubRoles (value) {
            var optionData = {}
            if (value === 'ทุกประเภทตัวแทน') {
                optionData = {
                    roles: 'sales-agent',
                    isVerified: 'approve'
                }
            } else {
                optionData = {
                    roles: 'sales-agent',
                    isVerified: 'approve',
                    subRoles: value
                }
            }
            this.$store.commit('saleagentList/setOption', optionData)
            this.$store.dispatch('saleagentList/fetchAgentlist')
        },
        closeRightPanel () {
            this.$refs.updateSaleAgentPanel.close()
        },

        onClickPanelActive () {
            this.$refs.saleAgentDetailsView.setisActive('active')
        },

        onClickPanelInActive () {
            this.$refs.saleAgentDetailsView.setisActive('inactive')
        },

        onClickPanelSave () {
            this.$refs.saleAgentDetailsView.patchUpdate()
        },

        getExportExcel () {
            const url = process.env.VUE_APP_BASE_URL + '/export/sales-agent-list?page=0&itemsPerPage=50&isVerified=approve&roles=sales-agent'
            // FileSaver.saveAs(blob, filename)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'filename')
            document.body.appendChild(link)
            link.click()
        }

    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-select {
    .v-select__selection {
        text-transform: capitalize;
    }
}
</style>
